// extracted by mini-css-extract-plugin
export default {"QuestionsWrapperInner":"Questions_QuestionsWrapperInner__E-jA3","QuestionsHeading":"Questions_QuestionsHeading__GivCM","QuestionsList":"Questions_QuestionsList__j-5BV"};